export default "__VITE_ASSET__BwnRyDR3__"